var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "app__header" }, [
        _vm.$route.path !== "/dashboard"
          ? _c(
              "div",
              { staticClass: "app__header-back" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      fab: "",
                      icon: "",
                      small: "",
                      color: _vm.isDark
                        ? "rgba(255, 255, 255, 0.7)"
                        : "rgba(0, 0, 0, 0.54)",
                    },
                    on: { click: _vm.goBack },
                  },
                  [_c("v-icon", [_vm._v("mdi-arrow-left-bold")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "app__header-brand",
            on: { click: _vm.navigateToDashboard },
          },
          [
            _c("v-img", {
              staticClass: "app__header-logo",
              attrs: { contain: "", src: _vm.logoSrc },
            }),
            _c(
              "p",
              {
                staticClass:
                  "orange--text mb-0 font-weight-bold text-body-2 app__header-host",
              },
              [_vm._v(_vm._s(_vm.getAppHost))]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "app__header-actions" },
          [
            _vm.isAuthenticated && _vm.$route.path !== "/stemp"
              ? _c("timer")
              : _vm._e(),
            _c(
              "v-btn",
              {
                attrs: { icon: "" },
                on: {
                  click: function ($event) {
                    return _vm.refreshContentUpdate()
                  },
                },
              },
              [
                _c("v-icon", { attrs: { large: "" } }, [
                  _vm._v("mdi-refresh-circle"),
                ]),
              ],
              1
            ),
            _vm.checkFeatureEnabled("tasks")
              ? _c(
                  "router-link",
                  { staticClass: "app__header-tasks", attrs: { to: "/tasks" } },
                  [
                    _c(
                      "v-badge",
                      { attrs: { content: _vm.tasksCount, overlap: "" } },
                      [
                        _c("v-icon", { attrs: { size: "30" } }, [
                          _vm._v("mdi-calendar-check"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("v-divider", { staticClass: "mx-1 grey darken-1" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }